module.exports = __webpack_public_path__ + "static/media/gd.9184926c.jpg";